<mat-grid-list [cols]="columns" [rowHeight]="rowHeight">
    <ng-container *ngFor="let choice of choices">
        <mat-grid-tile>
            <div class="tile-content"
                 [class.unselected]="enableSelect && choice.appPickerChoice != selected"
                 [class.compact]="compact"
            >
                <div *ngIf="enableSelect" class="selection-overlay" (click)="select(choice)">
                    <a *ngIf="choice.appPickerChoice == selected" class="uploader-button-remove icon-select">
                        <i class="i-done"></i>
                    </a>
                </div>

                <ng-container [ngTemplateOutlet]="choice.itemTemplate">
                </ng-container>

            </div>
        </mat-grid-tile>
    </ng-container>
</mat-grid-list>
